<template>
  <b-overlay
    :show="mostrarLoader"
    opacity="0.50"
    rounded="sm"
    spinner-variant="primary"
    spinner-type="grow"
  >
    <b-card>
      <div class="mb-1 text-center">
        <h4 class="leading-none font-medium text-primary">{{ this.rol.nombre }}</h4>
      </div>

      <b-row>
        <b-col
          lg="6"
          md="6"
          sm="12"
        >
          <b-card title="Permisos disponibles" class="shadow">
            <app-collapse type="border">
                <app-collapse-item v-for="(item,key) in permisos.permisos_disponibles" :isVisible="true">
                    <div slot="header">
                        <span v-if="item" style="font-size: 1.2rem;"><b>{{ Object.values(item)[0].modulo_seccion.nombre }}</b></span>
                    </div>

                    <div v-for="(value,key) in item" v-if="!permisos.permisos_asignados.includes(value.token_publico)" v-b-tooltip.right="value.descripcion">
                        {{ value.nombre_permiso }} <feather-icon icon="ArrowRightIcon" class="float-right" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="agregarPermiso(value.token_publico)" />
                    </div>
                </app-collapse-item>
            </app-collapse>
          </b-card>
        </b-col>

        <b-col
          lg="6"
          md="6"
          sm="12"
        >
          <b-card title="Permisos asignados">
            <app-collapse type="border" class="collapse-container">
                <app-collapse-item v-for="(item,key) in permisos.permisos_disponibles" :isVisible="true">
                    <div slot="header">
                        <span v-if="item" style="font-size: 1.2rem;"><b>{{ Object.values(item)[0].modulo_seccion.nombre }}</b></span>
                        <!--                          <strong>{{key}}</strong>-->
                    </div>
                    <div v-for="(value,key) in item" v-if="permisos.permisos_asignados.includes(value.token_publico)" v-b-tooltip.left="value.descripcion">
                      <feather-icon icon="ArrowLeftIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="eliminarPermiso(value.token_publico)" /> {{ value.nombre_permiso }}
                    </div>
                </app-collapse-item>
            </app-collapse>
          </b-card>
        </b-col>
          <b-button class="ml-3" variant="primary" :disabled="bloqueo_boton" id="button-with-loading" type="filled" v-on:click="asignarPermisos">Registrar</b-button>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import axios from '@/axios';
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
    data() {
        return {
            rol: {},
            permisos:{},
            asignados:[],
            bloqueo_boton: false,
            mostrarLoader: false
        }
    },

    methods: {
        cargarRol(){
            this.openLoadingInDiv()
            axios.get(`api/rol/${this.$route.params.token_publico}`
            )
                .then( response => {
                    this.rol = response.data
                    this.closeLoadingInDiv()
                });
        },

        cargarPermisos(){
            this.openLoadingInDiv()
            axios.get('api/rol/administrar_permisos/' ,{
                 params: {
                    rol :this.$route.params.token_publico
                  }})
                .then( response => {
                    this.permisos = response.data;
                    this.asignados= this.permisos.permisos_asignados.slice();
                    this.closeLoadingInDiv()
                });
        },

        asignarPermisos(e){
            this.openLoadingInDiv()
            axios
                .post('api/rol/asignar_permisos/',
                {rol:this.$route.params.token_publico , permisos_nuevos: this.permisos.permisos_asignados  }
                )
                .then(response => {
                    this.closeLoadingInDiv()
                    if(response === undefined){}
                    else{
                        this.showToast()
                    }
                })
                .catch(error => {
                    this.closeLoadingInDiv()
                    this.$errores_no_controlados(error)
                });
        },

        agregarPermiso(permiso_token){
            this.permisos.permisos_asignados.push(permiso_token);
        },

        eliminarPermiso(permiso_token){
             this.permisos.permisos_asignados.splice( this.permisos.permisos_asignados.indexOf(permiso_token),1);
        },

        openLoadingInDiv(){
            this.bloqueo_boton = true
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
            this.bloqueo_boton = false
        },
        showToast() {
          this.$toast.success({
            component: ToastificationContent,
            props: {
              title: 'Permisos',
              icon: 'SaveIcon',
              text: 'Cambios Guardados correctamente',
            },
          },
          {
            position: 'bottom-right',
          })
        },
    },

    mounted () {
        this.cargarRol();
        this.cargarPermisos();
    },
    components: {
      AppCollapse,
      AppCollapseItem,
    },
}
</script>

<style>
  .vs-collapse-item.open-item .vs-collapse-item--content{
    max-height: 100%!important;
  }

  .collapse-icon .card{
    cursor: pointer;
  }
</style>
